import React from 'react';
export default function VerifiedBadge({ verified, size = 16 }) {
  return verified ? <img src="/assets/images/global/verified.png" alt="Verified" style={{ display: 'inline-block', width: size, height: size, objectFit: 'contain', flexShrink: 0, verticalAlign: 'middle', marginInlineStart: 5 }} /> : null;
}
